import MainContent from 'features/unifiedFlow/components/MainContent'

import ContentLoadingOverlay from '../components/ContentLoadingOverlay'
import RightPanelEmpty from '../components/layout/RightPanelEmpty'
import { useWebsocketStatus } from '../hooks'

import CenterSection from './centerSection'
import LeftSection from './leftSection'

const Brief = () => {
  const { nglPending } = useWebsocketStatus()

  return (
    <MainContent className="flex-wrap pb-4" id="main-content-page">
      <ContentLoadingOverlay isLoading={nglPending} />
      <LeftSection />
      <CenterSection />
      <RightPanelEmpty />
    </MainContent>
  )
}

export default Brief
